import React, { Component } from 'react';
import DialogModal from '../DialogModal/DialogModal';
import Share from '../../Share/Share';

class ShareModal extends Component {
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      // initial focus set on toggle open of Share modal
      setTimeout(() => this.shareModal && this.shareModal.focus(), 250); // allow for modal transition in before setting focus
    }
  }

  render() {
    const {
      shareUrl,
      stopNumber,
      closeModal,
      published,
      uptoDate,
      tourId,
      isOpen,
      tourName,
      history,
      aid,
      sendHubspotEvent,
    } = this.props;

    const isFullscreen = 
    document.fullscreen || 
    document.webkitCurrentFullScreenElement || 
    document.mozFullScreenElement || 
    document.msFullscreenElement;

    return (
      <DialogModal
        closeModal={closeModal}
        className="share"
        isOpen={isOpen}
        // The parent element needs to be the scene element when in fullscreen mode
        // Otherwise, the modal will be rendered outside of the scene element
        // But as of 8/11/2025 voiceover cannot enter the modal when the parent element
        // is the scene element. So this is a workaround to allow voiceover to enter the modal
        // when not in fullscreen mode.
        parentElement={isFullscreen ? document.querySelector('#scene') : undefined}
        shouldCloseOnOverlayClick
      >
        <div
          className="modal"
          tabIndex={0}
          aria-label="share tour modal"
          ref={el => (this.shareModal = el)}
        >
          <Share
            tourId={tourId}
            stopNumber={stopNumber}
            tourName={tourName}
            shareUrl={shareUrl}
            published={published}
            uptoDate={uptoDate}
            embed
            showPublishButton
            closeModal={closeModal}
            history={history}
            aid={aid}
            sendHubspotEvent={sendHubspotEvent}
          />
        </div>
      </DialogModal>
    );
  }
}

export default ShareModal;
